import React, {PureComponent} from 'react'
import moment from 'moment';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import Loader from "../Simple/Loader";

export default class AutoGraph extends PureComponent {
    constructor(props) {
        super(props);
        const currency = 'EUR'

        const pageWidth = window.innerWidth || document.documentElement.clientWidth || doc.getElementsByTagName('body')[0].clientWidth

        this.state = {
            from: moment().subtract(7, 'day'),
            to: moment(),
            currency: currency,
            totalValues: null,
            chartOptions: {
                colors: ['#2196F3', '#F57C00', '#90CAF9', '#8E24AA', '#4CAF50', '#A5D6A7', '#6A1B9A', '#AB47BC'],
                chart: {
                    height: pageWidth > 600 ? 300 : 200,
                    type: 'line',
                    style: {fontFamily: 'Roboto'}
                },
                title: {
                    text: null
                },
                subtitle: {
                    text: null
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    type: 'datetime',
                    dateTimeLabelFormats: { // don't display the dummy year
                        day: '%e.%m.',
                        month: '%e.%b.',
                        year: '%b'
                    },
                    title: {
                        text: null
                    }
                },
                yAxis: [{
                    labels: {
                        format: '{value}'
                    },
                    title: {
                        text: null
                        //text: ""+$("#metric_select option:selected").text()+""
                    },
                    min: 0,
                },
                    {
                        labels: {
                            format: '{value}'
                        },
                        title: {
                            text: null
                            //text: ""+$("#metric_select option:selected").text()+""
                        },
                        min: 0,
                        opposite: true,
                        reversedStacks: false
                    }
                ], tooltip: {
                    shared: true,
                    useHTML: true,
                    backgroundColor: 'rgba(255,255,255,1)',
                    formatter: function () {
                        let points = this.points;
                        let groupChart = true
                        if (!groupChart) {
                            points.sort(function (a, b) {
                                return b.y - a.y
                            })
                        }
                        let pointsLength = points.length;
                        let weekDayNames = ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai'];
                        let monthNames = ['tammikuuta', 'helmikuuta', 'maaliskuuta', 'huhtikuuta', 'toukokuuta', 'kesäkuuta',
                            'heinäkuuta', 'elokuuta', 'syyskuuta', 'lokakuuta', 'marraskuuta', 'joulukuuta'
                        ];
                        let dateUnit = '.';
                        let date = new Date(points[0].key);
                        let dateString = date.getDate().toString();
                        dateString = weekDayNames[date.getDay()] + ' ' + dateString + dateUnit + ' ' + monthNames[date.getMonth()] + ' ' + date.getFullYear();
                        let tooltipMarkup = pointsLength ? '<div style="font-weight:600;padding-bottom:5px">' + dateString + '</div>' : '';
                        let index;
                        let unit = ''
                        let unitSecondary = ''
                        let decimalLength = 0
                        let decimalLengthSecondary = 2

                        tooltipMarkup += '<table>';

                        for (index = 0; index < pointsLength; index += 1) {
                            let value = (points[index].y).toFixed(decimalLength);
                            let unitString = unit;
                            if (groupChart) {
                                if (index === 0) {
                                    value = (points[index].y).toFixed(decimalLength);
                                    unitString = unit;
                                }
                                if (index === 1) {
                                    value = (points[index].y).toFixed(decimalLengthSecondary);
                                    unitString = unitSecondary;
                                }
                                if (index === 2) {
                                    value = (points[index].y).toFixed(decimalLengthSecondary);
                                    unitString = unitSecondary;
                                }
                            }
                            if (value > 0) {
                                tooltipMarkup += '<tr><td style="padding-right:10px"><span style="color:' + points[index].series.color + '">\u25CF</span> ' + points[index].series.name + '</td><td><b>' + value + ' ' + unitString + '</b></td></tr>';
                            }
                        }
                        tooltipMarkup += '</table>';

                        return tooltipMarkup;
                    }
                },
                series: [],
                plotOptions: {
                    line: {
                        marker: {
                            enabled: true
                        }
                    },
                    spline: {
                        marker: {
                            enabled: false
                        }
                    },
                    column: {
                        stacking: 'normal'
                    },
                }
            },
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.series !== this.props.series) {
            this.update(nextProps.series)
        }
    }

    componentDidMount() {
        this.update()
    }

    update = (series) => {
        let chartOptions = Object.assign(this.state.chartOptions, {series: series})
        this.setState({
            chartOptions
        });
    }

    render() {
        const {isLoading} = this.props
        const {chartOptions} = this.state;

        return (<>
                {!isLoading && <HighchartsReact
                    highcharts={Highcharts}
                    options={chartOptions}
                />}
                {isLoading && (
                    <div className="loader-wrapper mb-5">
                        <Loader/>
                    </div>
                )}
            </>
        )
    }
}
